<template>
  <div class="d-flex justify-content-between align-items-center mb-1">
    <div class="d-flex align-items-center">
      <b-button variant="outline-secondary" class="size-button-center" @click="$emit('toggle-menu')">
        <span><feather-icon icon="MenuIcon"/></span>
      </b-button>
      <div class="ml-1 d-flex align-items-center">
        <b-img :src="require('@/assets/images//icons/chatgpt.png')" class="chatgpt-icon" />
        <h5 class="ml-05 mb-0">{{ title }}</h5>
      </div>
    </div>
    <div class="d-flex align-items-center" v-if="should_show_buttons">
        <b-button variant="outline-secondary" class="mr-1" @click="$emit('new-chat')"><feather-icon icon="EditIcon" /></b-button>
        <b-button variant="outline-secondary" @click="$emit('toggle-layout')"><feather-icon icon="LayoutIcon" /></b-button>
    </div>
  </div>
</template>

<script>
import { BButton, BImg } from 'bootstrap-vue';

export default {
  name: 'ChatHeader',
  components: { BButton, BImg },
  props: {
    title: { type: String, required: true },
    sidebar_layout: { type: Boolean, required: true },
    should_show_buttons: { type: Boolean, default: true }
  },
}
</script>

<style scoped>
.chatgpt-icon { width: 25px; height: 25px; }
.ml-05 { margin-left: 0.5em; }
.size-button-center {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1rem;
  height: 3rem;
}
</style>
